var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: !_vm.$q.platform.is.mobile ? "q-pa-sm" : void 0 },
    [
      _c("q-table", {
        ref: "table",
        staticClass: "shadow-0 test",
        class: _vm.$q.platform.is.mobile ? "custom-space" : void 0,
        attrs: {
          pagination: _vm.server_pagination,
          data: _vm.topics,
          columns: _vm.columns,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.requestTopics
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c(
                  "div",
                  { staticClass: "col-4 col-xs-12 col-sm-6 col-md-4" },
                  [
                    _c("q-search", {
                      attrs: {
                        icon: "fas fa-search",
                        placeholder: _vm.$t("search"),
                        debounce: 500
                      },
                      model: {
                        value: _vm.filter,
                        callback: function($$v) {
                          _vm.filter = $$v
                        },
                        expression: "filter"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-3 col-xs-12 col-sm-6 col-md-4",
                    class: !_vm.$q.platform.is.mobile ? "q-ml-md" : ""
                  },
                  [
                    _c("q-option-group", {
                      staticClass: "radio",
                      attrs: {
                        color: "primary",
                        options: [
                          { label: _vm.$t("all_f"), value: false },
                          { label: _vm.$t("unanswered"), value: true }
                        ]
                      },
                      on: { input: _vm.fetchLists },
                      model: {
                        value: _vm.unanswered,
                        callback: function($$v) {
                          _vm.unanswered = $$v
                        },
                        expression: "unanswered"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2 col-xs-12 col-sm-4 col-md-3 q-my-sm" },
                  [
                    _c("q-btn", {
                      class: _vm.$q.platform.is.mobile ? "" : "absolute-right",
                      staticStyle: { height: "2.572em" },
                      attrs: {
                        color: "primary",
                        icon: "far fa-comment",
                        label: _vm.$t("new_topic")
                      },
                      on: { click: _vm.showNewTopicModal }
                    })
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n              "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  {
                    staticClass: "cursor-pointer",
                    attrs: { props: props },
                    nativeOn: {
                      click: function($event) {
                        return _vm.showTopicModal(props.row)
                      }
                    }
                  },
                  [
                    _c(
                      "q-td",
                      { key: "topic", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                      " +
                            _vm._s(
                              props.row.topic.length > 49
                                ? props.row.topic.substring(0, 50) + "..."
                                : props.row.topic
                            ) +
                            "\n                      "
                        ),
                        _c("q-tooltip", [_vm._v(_vm._s(props.row.topic))])
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "qty_answers", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                      " +
                            _vm._s(props.row.qty_answers) +
                            "\n                  "
                        )
                      ]
                    ),
                    _c("q-td", { key: "author", attrs: { props: props } }, [
                      _vm._v(
                        "\n                      " +
                          _vm._s(
                            props.row.author.length > 24
                              ? props.row.author.substring(0, 25) + "..."
                              : props.row.author
                          ) +
                          "\n                  "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "updated_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                      " +
                            _vm._s(props.row.updated_date) +
                            "\n                  "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("new-topic-modal", {
        attrs: { show: _vm.show_new_topic_modal },
        on: {
          hideModal: function($event) {
            return _vm.hideModal()
          }
        }
      }),
      _vm.show_topic_modal
        ? _c("topic-modal", {
            attrs: { topic: _vm.topic, show: _vm.show_topic_modal },
            on: {
              hideModal: function($event) {
                return _vm.hideModal()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }